export default __webpack_public_path__ + "static/media/twitter.4e5d640e.svg";